







import React from "react";
import "./PopularRentalLocations.css";

const locations = [

  {
    id: 1,
    title: "Mumbai Outstation Cab Service",
    image: "/images/keyword/1.jpg",
    location: "Mumbai",
    address: "Doorstep Pickup Across Mumbai & Suburbs",
    timing: "24×7 Cab Booking",
    timingDesc: "Available Every Day Including Holidays",
    service: "One Way & Round Trip",
    serviceDesc: "Comfortable Outstation Taxi Service",
    serviceIcon: "🚖",
    rating: "4.9",
    wait: "10 Min",
    support: "24×7",
    supportLabel: "Support",
  },

  {
    id: 2,
    title: "Mumbai Airport Taxi",
    image: "/images/keyword/90.jpg",
    location: "CSMIA Terminal 1 & 2",
    address: "Airport Pickup & Drop Service",
    timing: "24×7 Airport Transfers",
    timingDesc: "Flight Tracking & On-Time Pickup",
    service: "Airport Transfer",
    serviceDesc: "Professional Chauffeur Service",
    serviceIcon: "✈️",
    rating: "5.0",
    wait: "Fast",
    support: "Express",
    supportLabel: "Pickup",
  },

  // {
  //   id: 3,
  //   title: "Navi Mumbai Cab Service",
  //   image: "/images/location/location3.jpg",
  //   location: "Ghansoli • Vashi • Nerul",
  //   address: "Doorstep Pickup Across Navi Mumbai",
  //   timing: "24×7 Service",
  //   timingDesc: "Quick Response Time",
  //   service: "City Taxi",
  //   serviceDesc: "Local & Outstation Travel",
  //   serviceIcon: "🚕",
  //   rating: "4.9",
  //   wait: "15 Min",
  //   support: "Fast",
  //   supportLabel: "Booking",
  // },

  {
    id: 4,
    title: "Mumbai to Goa Cab",
    image: "/images/keyword/3.jpg",
    location: "Mumbai to Goa",
    address: "One Way & Round Trip Cab Service",
    timing: "Daily Service",
    timingDesc: "Flexible Pickup Time",
    service: "Long Distance Travel",
    serviceDesc: "Family & Corporate Trips",
    serviceIcon: "🌴",
    rating: "4.9",
    wait: "On Time",
    support: "Premium",
    supportLabel: "Travel",
  },

  // {
  //   id: 5,
  //   title: "Corporate Cab Service",
  //   image: "/images/location/location5.jpg",
  //   location: "Mumbai • Navi Mumbai • Thane",
  //   address: "Office Pickup & Drop",
  //   timing: "Monday - Sunday",
  //   timingDesc: "Corporate Contract Services",
  //   service: "Business Travel",
  //   serviceDesc: "Dedicated Corporate Fleet",
  //   serviceIcon: "💼",
  //   rating: "5.0",
  //   wait: "Priority",
  //   support: "Corporate",
  //   supportLabel: "Support",
  // },

  // {
  //   id: 6,
  //   title: "Konkan & Maharashtra Tours",
  //   image: "/images/location/location6.jpg",
  //   location: "Lonavala • Shirdi • Mahabaleshwar • Konkan",
  //   address: "Customized Tour Packages",
  //   timing: "Everyday Tours",
  //   timingDesc: "Weekend & Holiday Packages",
  //   service: "Tour Packages",
  //   serviceDesc: "Family, Group & Pilgrimage Tours",
  //   serviceIcon: "🏞️",
  //   rating: "4.8",
  //   wait: "Flexible",
  //   support: "Guide",
  //   supportLabel: "Travel",
  // },

];

function PopularRentalLocations() {
    return (

    <section className="location-section p-0 pt-2 mb-3">

      <div className="container">

        {/* Heading */}

        <div className="location-heading">

          <div className="heading-decoration">

            <span></span>
            <span></span>
            <span></span>

            <h2>

              Popular Travel Destinations

            </h2>

            <span></span>
            <span></span>
            <span></span>

          </div>

          <p>

            Shreesha Tours & Travels provides reliable taxi services
            from Mumbai, Navi Mumbai and Thane to popular tourist,
            pilgrimage and business destinations across Maharashtra
            and India. Enjoy safe, comfortable and affordable travel
            with our premium fleet and professional chauffeurs.

          </p>

        </div>

        {/* Cards */}

        <div className="location-grid">

          {

            locations.map((item) => (

              <div
                className="location-card "
                key={item.id}
              >

                <h3 className="text-center">

                  {item.title}

                </h3>

                <div className="location-image">

                  <img
                    src={item.image}
                    alt={item.title}
                  />

                </div>

                <ul className="location-info">
                                    <li>

                    <div className="info-icon">
                      📍
                    </div>

                    <div>

                      <strong>
                        {item.location}
                      </strong>

                      <p>
                        {item.address}
                      </p>

                    </div>

                  </li>

                  <li>

                    <div className="info-icon">
                      ⏰
                    </div>

                    <div>

                      <strong>
                        {item.timing}
                      </strong>

                      <p>
                        {item.timingDesc}
                      </p>

                    </div>

                  </li>

                  <li>

                    <div className="info-icon">
                      {item.serviceIcon}
                    </div>

                    <div>

                      <strong>
                        {item.service}
                      </strong>

                      <p>
                        {item.serviceDesc}
                      </p>

                    </div>

                  </li>

                </ul>

                <div className="location-bottom">

                  <div>

                    <h4>
                      {item.rating}
                    </h4>

                    <span>
                      Rating
                    </span>

                  </div>

                  <div>

                    <h4>
                      {item.wait}
                    </h4>

                    <span>
                      Response
                    </span>

                  </div>

                  <div>

                    <h4>
                      {item.support}
                    </h4>

                    <span>
                      {item.supportLabel}
                    </span>

                  </div>

                </div>

              </div>

            ))

          }

        </div>
              </div>

    </section>

  );

}

export default PopularRentalLocations;